import { c as _c } from "react/compiler-runtime";
import { cn } from 'cn';
import { Spinner } from '../ui/spinner';
export function CommentLoader(props) {
  const $ = _c(9);
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
  } else {
    className = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== className) {
    t0 = cn("flex min-h-20 items-center justify-center", className);
    $[3] = className;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Spinner />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== rest || $[7] !== t0) {
    t2 = <div className={t0} {...rest}>{t1}</div>;
    $[6] = rest;
    $[7] = t0;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}